import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import {useCliente} from "../../../../Profile.jsx";
import {useEditor} from "../../../../../../App.jsx";

const ProyectoEditor = () => {
    const { cliente, setCliente } = useCliente();
    const {stateEditor, setStateEditor} = useEditor();

    // console.log('Cliente:', cliente);
    const [proyecto, setProyecto] = useState({
        nombre: '',
        descripcion: '',
        cliente: '',
        fecha_inicio: '',
        fecha_fin: '',
        estado: 'no_iniciado',
    });

    const ESTADOS_PROYECTO = [
        { value: 'no_iniciado', label: 'No Iniciado' },
        { value: 'transcurriendo', label: 'Transcurriendo' },
        { value: 'acabado', label: 'Acabado' },
        { value: 'pendiente_aprobacion', label: 'Pendiente de Aprobación' },
        { value: 'en_espera', label: 'En Espera' },
        { value: 'en_revision', label: 'En Revisión' },
        { value: 'cancelado', label: 'Cancelado' },
        { value: 'pospuesto', label: 'Pospuesto' },
        { value: 'reiniciado', label: 'Reiniciado' },
        { value: 'entregado', label: 'Entregado' },
        { value: 'cerrado', label: 'Cerrado' },
        { value: 'en_prueba', label: 'En Prueba' },
        { value: 'en_implementacion', label: 'En Implementación' },
    ];

    useEffect(() => {
        if (stateEditor?.editorID && stateEditor?.editorID !== 'add') {
            // Cargar los datos del proyecto para editar
            axios.get(`/proyectos/${stateEditor?.editorID}/`)
                .then(response => {
                    setProyecto(response.data);
                })
                .catch(error => {
                    console.error('Error al cargar el proyecto:', error);
                });
        }
    }, [stateEditor?.editorID]);

    const handleChange = e => {
        const { name, value } = e.target;
        setProyecto(prevProyecto => ({
            ...prevProyecto,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            if (stateEditor?.editorID === 'add') {
                // Crear nuevo proyecto
                proyecto.cliente = cliente.id;
                console.log("proyecto", proyecto);
                axios.post('/proyectos/', proyecto)
                    .then(response => {
                        if (response.status === 201) {
                            if (confirm('Proyecto creado, ¿quiere volver a la lista de proyectos?')) {
                                setStateEditor({
                                    ...stateEditor,
                                    editorID: cliente.id,
                                    editorType: "cliente_view",
                                    editor: true
                                });
                            } else {
                                setStateEditor({
                                    ...stateEditor,
                                    editorID: response.data.id
                                });
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error al crear el proyecto:', error);
                    });
            } else {
                // Editar proyecto existente
                axios.put(`/proyectos/${stateEditor?.editorID}/`, proyecto)
                    .then(response => {
                        if (response.status === 200) {
                            if (confirm('Proyecto modificado, ¿quiere volver a la lista de proyectos?')) {
                                setStateEditor({
                                    ...stateEditor,
                                    editorID: cliente.id,
                                    editorType: "cliente_view",
                                    editor: true
                                });
                            } else {
                                setStateEditor({
                                    ...stateEditor,
                                    editorID: response.data.id
                                });                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error al modificar el proyecto:', error);
                    });
            }
        } catch (error) {
            console.error('Error al guardar el proyecto:', error);
        }
    };

    const handleDelete = async () => {
        try {
            if (confirm('¿Quiere usted borrar este proyecto?')) {
                axios.delete(`/proyectos/${stateEditor?.editorID}`)
                    .then(() => {
                        setStateEditor({
                            ...stateEditor,
                            editor: true,
                            editorType: "cliente_view",
                            editorID: cliente.id

                        });
                    })
                    .catch(error => {
                        console.error('Error al borrar el proyecto:', error);
                    });
            }
        } catch (error) {
            console.error('Error al borrar el proyecto:', error);
        }
    };

    return (
        <div className="h-full mx-auto p-6 pt-2">
            <button
                className="absolute top-3 right-2 bg-blue-500 text-white px-3 py-1 rounded"
                onClick={() => {
                    setStateEditor({
                        ...stateEditor,
                        editorType: "proyecto_viewer",
                        editor: true
                    });
                }}
            >
                Atras
            </button>
            <h2 className="text-3xl mb-4">Edición de Proyecto</h2>

            <div className="mb-4">

                <h2 className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Detalles del Proyecto</h2>
                {/*{cliente.nombre? <p><strong>Cliente:</strong> {cliente.nombre} {cliente.apellido}</p> : <p><strong>Cliente:</strong> No asignado</p>    }*/}


                <h2 className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Detalles del Proyecto</h2>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <input
                            name="nombre"
                            value={proyecto.nombre}
                            onChange={handleChange}
                            className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                            type="text"
                            placeholder="Nombre del Proyecto*"
                        />
                    </div>
                    <div className="w-full md:w-1/2 px-3">
                        <select
                            name="estado"
                            value={proyecto.estado}
                            onChange={handleChange}
                            className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                        >
                            {ESTADOS_PROYECTO.map((estado) => (
                                <option key={estado.value} value={estado.value}>
                                    {estado.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="mb-4">
                <h2 className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Fechas</h2>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                        <input
                            name="fecha_inicio"
                            value={proyecto.fecha_inicio}
                            onChange={handleChange}
                            className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                            type="date"
                            placeholder="Fecha de Inicio"
                        />
                    </div>
                    <div className="w-full md:w-1/2 px-3">
                        <input
                            name="fecha_fin"
                            value={proyecto.fecha_fin}
                            onChange={handleChange}
                            className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                            type="date"
                            placeholder="Fecha de Fin (opcional)"
                        />
                    </div>
                </div>
            </div>

            <div className="mb-4">
                <h2 className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Descripción</h2>
                <textarea
                    name="descripcion"
                    value={proyecto.descripcion}
                    onChange={handleChange}
                    className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                    placeholder="Descripción del Proyecto"
                />
            </div>

            <div className="flex items-center justify-between">
                <button
                    onClick={handleSubmit}
                    className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    type="button"
                >
                    Confirmar
                </button>

                {stateEditor?.editorID && stateEditor?.editorID !== 'add' && (
                    <button
                        onClick={handleDelete}
                        className="bg-transparent hover:bg-gray-500 text-gray-700 dark:text-gray-300 font-semibold hover:text-white py-2 px-4 border border-gray-500 hover:border-transparent rounded"
                        type="button"
                    >
                        Borrar
                    </button>
                )}
            </div>
        </div>
    );
};

export default ProyectoEditor;
